/* projects/speaker-platform/src/app/organisms/admin/texts-list-filters/texts-list-filters.component.scss */
/*# sourceMappingURL=texts-list-filters.component-7LTTLR6E.css.map */
